import type { ProjectId } from 'owa-timestream-types';
import type ExtendedPropertyType from 'owa-service/lib/contract/ExtendedPropertyType';
import extendedPropertyUri from 'owa-service/lib/factory/extendedPropertyUri';
import getItem from './getItem';
import getTargetMailbox from './getTargetMailbox';

const SecondaryKey = extendedPropertyUri({
    PropertyTag: '0x3662',
    PropertyType: 'String',
});

export default async function getSdsSecondaryKey(projectId: ProjectId, itemId: string) {
    // TODO: cache item ID -> secondary key
    const targetMailbox = getTargetMailbox(projectId);

    const item = await getItem(targetMailbox, itemId, [SecondaryKey]);
    if (item) {
        const extendedProperties: ExtendedPropertyType[] = item.ExtendedProperty ?? [];
        const secondaryKey = extendedProperties.filter(p => {
            return p.ExtendedFieldURI?.PropertyTag == SecondaryKey.PropertyTag;
        })[0];
        return secondaryKey?.Value as string;
    }

    return '';
}
